
        import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-theme/components/refine-search/js/refine-search';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/components/facet/js/toggle';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/node_modules/ui-core/components/facet-date/js/facet-date';
  
import '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/widgets/search-result/js/search-result';
  
import AdvancedSearch from '/mnt/ssd/na101/home/literatum/sourcegit/ui-products-branches/maint-250304-2a49dd84/ui-products/nrc/widgets/advanced-search/js/advanced-search';  
const main = (UX) => {
    const $refine = Array.prototype.slice.call(document.querySelectorAll('.refineSearch,.advanced-search')),
        $toggle = Array.prototype.slice.call(document.getElementsByClassName('facet')),
        $facetDate = Array.prototype.slice.call(document.getElementsByClassName('range-slider')),
        $searchResult = Array.prototype.slice.call(document.getElementsByClassName('search-result')),
        $advancedSearch = document.querySelector('.advanced-search')

try {
        if ($refine.length ) {
            UX.refine.init($refine);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($toggle.length ) {
            UX.toggle.init($toggle);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($facetDate.length ) {
            UX.facetDate.init($facetDate);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($searchResult.length ) {
            UX.searchResult.init($searchResult);
        }
    } catch (err) {
        console.error(err);
    }
    
try {
        if ($advancedSearch ) {
            UX.advancedSearch = new AdvancedSearch($advancedSearch).initialize()
        }
    } catch (err) {
        console.error(err);
    }
    
}

        export default main;
        